import styled from 'styled-components';
import colors from 'styles/colors';
import {
  matchGradientButton,
  matchOutlineButton,
  matchPillColor,
  matchSurface,
} from 'styles/match';

/** Faixa "Licitação compatível" exibida no topo do card da licitação (Figma 4:4628). */
export const Container = styled.div`
  ${matchSurface}
  flex-wrap: wrap;
  margin-bottom: 16px;

  .match-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .match-label {
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${colors.$dark};
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }

  .match-label img {
    display: block;
    width: 26px;
    height: 24px;
  }

  .match-pills {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .match-pill {
    padding: 4px 8px;
    border: 1px solid ${matchPillColor};
    border-radius: 4px;
    color: ${matchPillColor};
    font-size: 14px;
    line-height: 1.15;
    white-space: nowrap;
    background: transparent;
  }

  /* Contador dos itens que casaram — clicável, expande a lista. */
  .match-pill--itens {
    cursor: pointer;
    font-weight: 600;

    &:disabled {
      cursor: default;
    }

    &:not(:disabled):hover {
      background: rgba(54, 103, 147, 0.08);
    }
  }

  .match-chevron {
    margin-left: 4px;
    font-size: 11px;
  }

  /* Nível de compatibilidade no dialeto dos badges do card (URGENTE, CAPAG). */
  .match-nivel {
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.4px;
    white-space: nowrap;
  }

  .match-nivel--alta {
    background: ${colors.$success};
    color: #fff;
  }

  .match-nivel--media {
    background: ${colors.$warning};
    color: ${colors.$dark};
  }

  /* Baixa só aparece quando região E valor casam — visual discreto. */
  .match-nivel--baixa {
    background: #e9ecef;
    color: ${colors.$dark};
  }

  /* Lista expandida dos itens do edital que casaram com o segmento. */
  .match-itens-lista {
    flex-basis: 100%;
    margin: 4px 0 0;
    padding: 8px 12px;
    list-style: none;
    border-top: 1px dashed ${colors.$primary};

    li {
      display: flex;
      gap: 8px;
      padding: 3px 0;
      color: ${colors.$dark};
      font-size: 14px;
      line-height: 1.35;
    }
  }

  .match-check {
    color: ${colors.$primary_green};
    font-weight: 700;
    flex-shrink: 0;
  }

  .match-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .match-btn-video {
    ${matchOutlineButton}
  }

  .match-btn-personalizar {
    ${matchGradientButton}
  }

  @media (max-width: 991px) {
    .match-actions {
      margin-left: 0;
    }
  }
`;
